import styled from 'styled-components';
import { SYS_BREAKPOINT_SM, SYS_BREAKPOINT_MD, SYS_BREAKPOINT_LG, SYS_BREAKPOINT_XL, } from '@oneaudi/unified-web-common';
export const FilterContainer = styled.section `
  position: relative;
  margin: 0 16px var(--spacing-relative-2xl);
  background-color: #fff;
  @media (min-width: ${SYS_BREAKPOINT_SM}) {
    margin: 0 28px var(--spacing-relative-2xl);
  }
  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    margin: 0 40px var(--spacing-relative-2xl);
  }
  @media (min-width: ${SYS_BREAKPOINT_LG}) {
    margin: 0 60px var(--spacing-relative-2xl);
  }
  @media (min-width: ${SYS_BREAKPOINT_XL}) {
    margin: 0 96px var(--spacing-relative-2xl);
  }
`;
